/**
 * @param {string} string - non pascal strin
 * @returns SpaceAround
 *
 * @example
 * pascalize('space-around')
 */
var pascalize = function pascalize(string) {
  if (!string) {
    return '';
  }

  return string.replace(/[-_]+/g, ' ').replace(/[^\w\s]/g, '').replace(/\s+(.)(\w+)/g, function ($1, $2, $3) {
    return $2.toUpperCase() + $3.toLowerCase();
  }).replace(/\s/g, '').replace(/\w/, function (s) {
    return s.toUpperCase();
  });
};

export default pascalize;